// import Home from '../pages/Home/Home';
// import Product from '../pages/Product/Product';
// import ProductDetails from '../pages/Product/ProductDetails';
// import Cart from '../pages/Cart/Cart';
// import Checkout from '../pages/Checkout/Checkout';
// import Order from '../pages/Order/Order'
// import OrderDetails from '../pages/Order/OrderDetails'
// import PageNotFound from '../pages/Home/PageNotFound'
// import Thanks from '../pages/Thanks/Thanks'
// import Store from '../pages/Store/Store'
// import Contact from '../pages/Contact/Contact'
// import Search from '../pages/Search/Search'
// import Size from '../pages/Size/Size'
// import TuyenDung from '../pages/TuyenDung/tuyendung'
// import Login from '../pages/User/Login';
// import Profile from '../pages/User/Profile';
// import GioiThieu from '../pages/Info/GioiThieu';
// import HuongDanMuaHang from '../pages/Info/HuongDanMuaHang';
// import ChinhSachGiaoHang from '../pages/Info/ChinhSachGiaoHang';
// import ChinhSachDoiHang from '../pages/Info/ChinhSachDoiTra';
// import ChinhSachDoiTra from '../pages/Info/ChinhSachDoiTra';
// import ChinhSachBaoMat from '../pages/Info/ChinhSachBaoMatThongTin';
// import LienHe from '../pages/Info/LienHe';
// import BaoTri from '../pages/Info/BaoTri';
// import HuongDanSuDung from '../pages/Info/HuongDanSuDung';

// const routes = [
//   {
//     path: '/',
//     element: Home,
//     private: false,
//   },
//   {
//     path: '/index.html',
//     element: Home,
//     private: false,
//   },
//   {
//     path: '/san-pham/:productId.html',
//     element: ProductDetails,
//     private: false,
//   },
//   {
//     path: '/:group/:categoryId.html',
//     element: Product,
//     private: false,
//   },
//   {
//     path: '/:categoryId.html',
//     element: Product,
//     private: false,
//   },
//   {
//     path: '/gio-hang.html',
//     element: Cart,
//     private: false,
//   },
//   {
//     path: '/checkout',
//     element: Checkout,
//     private: false,
//   },
//   {
//     path: '/order',
//     element: Order,
//     private: false,
//   },
//   {
//     path: '/orderdetail',
//     element: OrderDetails,
//     private: false,
//   },
//   {
//     path: '/pagenotfound',
//     element: PageNotFound,
//     private: false,
//   },
//   {
//     path: '/xac-nhan-don-hang.html',
//     element: Thanks,
//     private: false,
//   },
//   {
//     path: '/cua-hang.html',
//     element: Store,
//     private: false,
//   },
//   {
//     path: '/lien-he.html',
//     element: Contact,
//     private: false,
//   },
//   {
//     path: '/tim-kiem.html',
//     element: Search,
//     private: false,
//   },
//   {
//     path: '/size',
//     element: Size,
//     private: false,
//   },
//   {
//     path: '/tuyen-dung.html',
//     element: TuyenDung,
//     private: false,
//   },
//   {
//     path: '/login',
//     element: Login,
//     private: false,
//   },
//   {
//     path: '/gioi-thieu',
//     element: GioiThieu,
//     private: false,
//   },
//   {
//     path: '/huong-dan-mua-hang',
//     element: HuongDanMuaHang,
//     private: false,
//   },
//   {
//     path: '/chinh-sach-giao-hang',
//     element: ChinhSachGiaoHang,
//     private: false,
//   },
//   {
//     path: '/chinh-sach-doi-tra',
//     element: ChinhSachDoiTra,
//     private: false,
//   },
//    {
//     path: '/chinh-sach-bao-mat',
//     element: ChinhSachBaoMat,
//     private: false,
//   },
//   {
//     path: '/lien-he',
//     element: LienHe,
//     private: false,
//   },
//   {
//     path: '/profile',
//     element: Profile,
//     private: true,
//   },
//   {
//     path: '/bao-tri',
//     element: BaoTri,
//     private: false,
//   },
//   {
//     path: '/huong-dan-su-dung',
//     element: HuongDanSuDung,
//     private: false,
//   },
//   {
//     path: '*',
//     element: PageNotFound,
//     private: false,
//   }
// ];

// export default routes;
import Home from '../pages/Home/Home';
import Product from '../pages/Product/Product';
import ProductDetails from '../pages/Product/ProductDetails';
import Cart from '../pages/Cart/Cart';
import Checkout from '../pages/Checkout/Checkout';
import Order from '../pages/Order/Order';
import OrderDetails from '../pages/Order/OrderDetails';
import PageNotFound from '../pages/Home/PageNotFound';
import Thanks from '../pages/Thanks/Thanks';
import Store from '../pages/Store/Store';
import Contact from '../pages/Contact/Contact';
import Search from '../pages/Search/Search';
import Size from '../pages/Size/Size';
//import TuyenDung from '../pages/TuyenDung/TuyenDung'; // kiểm tra chính xác tên file
import Login from '../pages/User/Login';
import Profile from '../pages/User/Profile';
import GioiThieu from '../pages/Info/GioiThieu';
import HuongDanMuaHang from '../pages/Info/HuongDanMuaHang';
import ChinhSachGiaoHang from '../pages/Info/ChinhSachGiaoHang';
import ChinhSachDoiTra from '../pages/Info/ChinhSachDoiTra';
import ChinhSachBaoMat from '../pages/Info/ChinhSachBaoMatThongTin';
import LienHe from '../pages/Info/LienHe';
import BaoTri from '../pages/Info/BaoTri';
import HuongDanSuDung from '../pages/Info/HuongDanSuDung';

const routes = [
  // --- static, specific routes first ---
  { path: '/', element: Home, private: false },
  { path: '/index.html', element: Home, private: false },
  { path: '/san-pham/:productId.html', element: ProductDetails, private: false },

  // site pages (static)
  { path: '/tim-kiem.html', element: Search, private: false },
  { path: '/gio-hang.html', element: Cart, private: false },
  { path: '/xac-nhan-don-hang.html', element: Thanks, private: false },
  { path: '/cua-hang.html', element: Store, private: false },
  { path: '/lien-he.html', element: Contact, private: false }, // giữ 1 dạng .html
  //{ path: '/tuyen-dung.html', element: TuyenDung, private: false },

  // other static routes (non .html)
  { path: '/checkout', element: Checkout, private: false },
  { path: '/order', element: Order, private: false },
  { path: '/orderdetail', element: OrderDetails, private: false },
  { path: '/pagenotfound', element: PageNotFound, private: false },
  { path: '/size', element: Size, private: false },
  { path: '/login', element: Login, private: false },
  { path: '/gioi-thieu', element: GioiThieu, private: false },
  { path: '/huong-dan-mua-hang', element: HuongDanMuaHang, private: false },
  { path: '/chinh-sach-giao-hang', element: ChinhSachGiaoHang, private: false },
  { path: '/chinh-sach-doi-tra', element: ChinhSachDoiTra, private: false },
  { path: '/chinh-sach-bao-mat', element: ChinhSachBaoMat, private: false },
  // nếu bạn muốn giữ trang Info LienHe (trong thư mục Info), đổi path hoặc dùng redirect
  // { path: '/lien-he-info', element: LienHe, private: false },

  { path: '/profile', element: Profile, private: true },
  { path: '/bao-tri', element: BaoTri, private: false },
  { path: '/huong-dan-su-dung', element: HuongDanSuDung, private: false },

  // --- dynamic routes last ---
  { path: '/:group/:categoryId.html', element: Product, private: false },
  { path: '/:categoryId.html', element: Product, private: false },

  // fallback
  { path: '*', element: PageNotFound, private: false },
];

export default routes;
